import React, { useState } from "react";
import {
  FaCheckCircle,
  FaEnvelope,
  FaMailBulk,
  FaPaperPlane,
  FaUser,
} from "react-icons/fa";
import { saveMessageContactForm } from "./../../services/contactformServices";

const FormContact = () => {
  const [notificationSent, setNotificationSent] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    setNotificationSent(false);
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const { name, email, message } = formData;

    try {
      setIsSubmitting(true);

      await saveMessageContactForm({
        name,
        email,
        message,
      });

      setNotificationSent(true);
      setFormData({
        name: "",
        email: "",
        message: "",
      });
    } catch (error) {
      console.error(
        "Erreur lors de l'envoi de la notification ou de la sauvegarde du message",
        error
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="relative overflow-hidden bg-[#f8fafc] py-16 text-slate-950 dark:bg-[#070b14] dark:text-white sm:py-20">
      <div className="absolute -left-20 top-16 h-64 w-64 rounded-full bg-sky-500/10 blur-3xl" />
      <div className="absolute -right-20 bottom-10 h-64 w-64 rounded-full bg-orange-500/10 blur-3xl" />

      <div className="relative mx-auto grid max-w-6xl gap-8 px-4 sm:px-6 lg:grid-cols-[0.9fr_1.1fr] lg:px-8">
        <div className="flex flex-col justify-center">
          <div className="inline-flex w-fit items-center gap-2 rounded-full border border-sky-200 bg-sky-50 px-3 py-2 text-xs font-bold uppercase tracking-[0.2em] text-sky-700 dark:border-sky-400/20 dark:bg-sky-500/10 dark:text-sky-200">
            <FaMailBulk />
            Contact
          </div>

          <h2 className="mt-5 font-heading text-4xl font-bold leading-tight text-slate-950 dark:text-white sm:text-5xl">
            Une question sur Judo Coach Pro ?
          </h2>

          <p className="mt-5 max-w-xl text-base font-medium leading-8 text-slate-600 dark:text-white/55">
            Vous êtes judoka, enseignant, dirigeant de club ou simplement curieux
            de découvrir l’application ? Envoyez un message, je vous répondrai
            rapidement.
          </p>

          <div className="mt-8 grid gap-3 sm:grid-cols-2 lg:grid-cols-1">
            <div className="rounded-[1.5rem] border border-slate-200 bg-white p-4 shadow-sm dark:border-white/10 dark:bg-white/[0.05]">
              <p className="text-sm font-bold text-slate-950 dark:text-white">
                Pour les judokas
              </p>
              <p className="mt-1 text-sm font-medium leading-6 text-slate-500 dark:text-white/45">
                Compte, profil judoka, résultats, grades, techniques et quizz.
              </p>
            </div>

            <div className="rounded-[1.5rem] border border-slate-200 bg-white p-4 shadow-sm dark:border-white/10 dark:bg-white/[0.05]">
              <p className="text-sm font-bold text-slate-950 dark:text-white">
                Pour les coachs
              </p>
              <p className="mt-1 text-sm font-medium leading-6 text-slate-500 dark:text-white/45">
                Groupes, invitations, suivi des résultats, passages de grade et
                statistiques.
              </p>
            </div>
          </div>
        </div>

        <form
          className="rounded-[2rem] border border-slate-200 bg-white p-5 shadow-2xl shadow-slate-200/70 dark:border-white/10 dark:bg-[#101827] dark:shadow-black/30 sm:p-6"
          onSubmit={handleSubmit}
        >
          <div className="mb-6">
            <p className="text-sm font-bold uppercase tracking-[0.18em] text-sky-600 dark:text-sky-300">
              Formulaire
            </p>
            <h3 className="mt-2 font-heading text-2xl font-bold text-slate-950 dark:text-white">
              Envoyer un message
            </h3>
          </div>

          <div className="space-y-5">
            <div>
              <label
                htmlFor="name"
                className="mb-2 block text-sm font-bold text-slate-700 dark:text-white/80"
              >
                Nom et prénom
              </label>

              <div className="relative">
                <FaUser className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />

                <input
                  type="text"
                  id="name"
                  name="name"
                  className="min-h-12 w-full rounded-2xl border border-slate-200 bg-slate-50 py-3 pl-11 pr-4 text-sm font-semibold text-slate-900 outline-none transition focus:border-sky-400 focus:bg-white focus:ring-4 focus:ring-sky-500/10 dark:border-white/10 dark:bg-white/[0.05] dark:text-white dark:focus:border-sky-300 dark:focus:bg-white/[0.08]"
                  placeholder="Votre nom et prénom"
                  required
                  value={formData.name}
                  onChange={handleInputChange}
                />
              </div>
            </div>

            <div>
              <label
                htmlFor="email"
                className="mb-2 block text-sm font-bold text-slate-700 dark:text-white/80"
              >
                Adresse email
              </label>

              <div className="relative">
                <FaEnvelope className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />

                <input
                  type="email"
                  id="email"
                  name="email"
                  className="min-h-12 w-full rounded-2xl border border-slate-200 bg-slate-50 py-3 pl-11 pr-4 text-sm font-semibold text-slate-900 outline-none transition focus:border-sky-400 focus:bg-white focus:ring-4 focus:ring-sky-500/10 dark:border-white/10 dark:bg-white/[0.05] dark:text-white dark:focus:border-sky-300 dark:focus:bg-white/[0.08]"
                  placeholder="mail@gmail.com"
                  required
                  value={formData.email}
                  onChange={handleInputChange}
                />
              </div>
            </div>

            <div>
              <label
                htmlFor="message"
                className="mb-2 block text-sm font-bold text-slate-700 dark:text-white/80"
              >
                Message
              </label>

              <textarea
                id="message"
                name="message"
                rows="6"
                className="w-full resize-none rounded-2xl border border-slate-200 bg-slate-50 p-4 text-sm font-semibold text-slate-900 outline-none transition focus:border-sky-400 focus:bg-white focus:ring-4 focus:ring-sky-500/10 dark:border-white/10 dark:bg-white/[0.05] dark:text-white dark:focus:border-sky-300 dark:focus:bg-white/[0.08]"
                placeholder="Votre message..."
                required
                value={formData.message}
                onChange={handleInputChange}
              />
            </div>

            <button
              type="submit"
              disabled={isSubmitting}
              className="inline-flex min-h-12 w-full items-center justify-center gap-2 rounded-2xl bg-gradient-to-r from-sky-600 to-blue-700 px-5 py-3 text-sm font-bold text-white shadow-lg shadow-sky-600/20 transition hover:-translate-y-0.5 hover:shadow-xl active:translate-y-0 disabled:cursor-not-allowed disabled:opacity-70"
            >
              {isSubmitting ? (
                "Envoi en cours..."
              ) : (
                <>
                  <FaPaperPlane />
                  Envoyer mon message
                </>
              )}
            </button>

            {notificationSent && (
              <div className="flex items-center gap-3 rounded-2xl border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm font-bold text-emerald-700 dark:border-emerald-400/20 dark:bg-emerald-500/10 dark:text-emerald-200">
                <FaCheckCircle />
                Votre message a bien été envoyé.
              </div>
            )}
          </div>
        </form>
      </div>
    </section>
  );
};

export default FormContact;